export enum InstalacaoEnergiaEletricaTipo {
  CONCESSIONARIA = 'CONCESSIONARIA',
  CLANDESTINA = 'CLANDESTINA',
}
